import ReviewsComponent from "./Reviews.vue";
import ReviewsMobComponent from "./ReviewsMob.vue";
import AverageRatingComponent from "./AverageRating.vue";

window.FPI.extension.register("#central-rnr-widget-review-listing", {
  mounted(element) {
    if (window.innerWidth <= 430) {
      window.FPI.extension.mountApp({
        element,
        component: ReviewsMobComponent,
      });
    } else {
      window.FPI.extension.mountApp({
        element,
        component: ReviewsComponent,
      });
    }
  },
});

window.FPI.extension.register("#central-rnr-widget-avg-rating", {
  mounted(element) {
    window.FPI.extension.mountApp({
      element,
      component: AverageRatingComponent,
    });
  },
});
